import { render, staticRenderFns } from "./NeedsAnalysis.vue?vue&type=template&id=0e712f7e&scoped=true&"
import script from "./NeedsAnalysis.vue?vue&type=script&lang=js&"
export * from "./NeedsAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./NeedsAnalysis.vue?vue&type=style&index=0&id=0e712f7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e712f7e",
  null
  
)

export default component.exports